import React, { useState, useEffect } from 'react';
import api from '../services/api';
import './Dashboard.css';

function Dashboard({ employeeName, onNavigate }) {
  const [stats, setStats] = useState({ customers: 0, products: 0, orders: 0 });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadData = async () => {
      try {
        const companyID = localStorage.getItem('companyID');
        const [customers, products] = await Promise.all([
          api.getCustomers(companyID),
          api.getProducts(companyID)
        ]);
        setStats({
          customers: customers.data.customers?.length || 0,
          products: products.data.products?.length || 0,
          orders: 0
        });
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };
    loadData();
  }, []);

  const menuItems = [
    { id: 'customers', title: 'Customers', icon: '👥', color: '#667eea', desc: 'View customers & outstanding' },
    { id: 'products', title: 'Products', icon: '📦', color: '#48bb78', desc: 'Browse products & stock' },
    { id: 'orders', title: 'New Order', icon: '🛒', color: '#ed8936', desc: 'Create sales order' },
    { id: 'history', title: 'Order History', icon: '📋', color: '#9b59b6', desc: 'View past orders' },
  ];

  if (loading) return <div className="dashboard-loading">Loading dashboard...</div>;

  return (
    <div className="dashboard">
      <header className="dashboard-header">
        <div className="header-left">
          <h1>📱 Sales Order App</h1>
          <p>Welcome back, {employeeName}!</p>
        </div>
        <div className="header-right">
          <span className="stats-badge">Today: {new Date().toLocaleDateString()}</span>
        </div>
      </header>

      <div className="stats-grid">
        <div className="stat-card customers">
          <span className="stat-icon">👥</span>
          <div className="stat-info">
            <span className="stat-value">{stats.customers}</span>
            <span className="stat-label">Active Customers</span>
          </div>
        </div>
        <div className="stat-card products">
          <span className="stat-icon">📦</span>
          <div className="stat-info">
            <span className="stat-value">{stats.products}</span>
            <span className="stat-label">Products</span>
          </div>
        </div>
        <div className="stat-card orders">
          <span className="stat-icon">🛒</span>
          <div className="stat-info">
            <span className="stat-value">{stats.orders}</span>
            <span className="stat-label">Today's Orders</span>
          </div>
        </div>
      </div>

      <div className="menu-grid">
        {menuItems.map(item => (
          <div
            key={item.id}
            className="menu-card"
            onClick={() => onNavigate(item.id)}
            style={{ borderTopColor: item.color }}
          >
            <span className="menu-icon" style={{ backgroundColor: item.color }}>{item.icon}</span>
            <div className="menu-info">
              <h3>{item.title}</h3>
              <p>{item.desc}</p>
            </div>
            <span className="menu-arrow">→</span>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Dashboard;
